/* ---------- helpers ---------- */
function getDuration(url) {
	return new Promise((resolve, reject) => {
	  const audio = new Audio();
	  audio.preload = 'metadata';
	  audio.src = url;
	  audio.onloadedmetadata = () =>
		isFinite(audio.duration) ? resolve(audio.duration) : reject('bad duration');
	  audio.onerror = reject;
	});
}

/* ---------- Duration tracking ---------- */
window.vinylDurations = {
  sideA: 0,
  sideB: 0
};

function setATCOverlay(enabled, buttonSelector = '#zakeke-product-button-1', overlayId = 'atc-block-overlay') {
  const atcButton = document.querySelector(buttonSelector);
  let overlay = document.getElementById(overlayId);
  if (enabled) {
    if (!atcButton) return;
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = overlayId;
      overlay.style.position = 'absolute';
      overlay.style.background = 'rgba(255,255,255,0)';
      overlay.style.zIndex = 9999;
      overlay.style.cursor = 'not-allowed';
      overlay.style.top = 0;
      overlay.style.left = 0;
      overlay.style.width = atcButton.offsetWidth + 'px';
      overlay.style.height = atcButton.offsetHeight + 'px';
      overlay.style.pointerEvents = 'all';
      // Make sure the parent is positioned
      const parent = atcButton.parentNode;
      if (parent && window.getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      parent.appendChild(overlay);
    } else {
      // Update overlay size in case button size changed
      overlay.style.width = atcButton.offsetWidth + 'px';
      overlay.style.height = atcButton.offsetHeight + 'px';
    }
    // Position overlay over the button
    const rect = atcButton.getBoundingClientRect();
    const parentRect = atcButton.parentNode.getBoundingClientRect();
    overlay.style.top = (rect.top - parentRect.top) + 'px';
    overlay.style.left = (rect.left - parentRect.left) + 'px';
  } else {
    if (overlay) overlay.remove();
  }
}

function updateATCButton() {
  const config = window.vinylConfig;
  if (!config) {
    console.error('Vinyl configuration not found');
    return;
  }
  
  const atcButton = document.querySelector('#zakeke-product-button-1');
  const customizeButton = document.querySelector('#zakeke-product-button');
  const maxDuration = config.maxMinutes * 60; // Convert minutes to seconds
  const sideAExceeded = window.vinylDurations.sideA > maxDuration;
  const sideBExceeded = window.vinylDurations.sideB > maxDuration;
  
  // Remove existing notifications
  const existingNotifications = document.querySelectorAll('.vinyl-duration-warning');
  existingNotifications.forEach(notification => notification.remove());
  
  // Show warnings if any side exceeds
  if (sideAExceeded || sideBExceeded) {
    showDurationWarnings(sideAExceeded, sideBExceeded);
  }
  
  // Control original ATC button (existing logic)
  if (sideAExceeded || sideBExceeded) {
    // Disable button
    if (atcButton) {
      atcButton.disabled = true;
      atcButton.style.opacity = '0.5';
      atcButton.style.cursor = 'not-allowed';
    }
    setATCOverlay(true);
  } else {
    // Enable button
    if (atcButton) {
      atcButton.disabled = false;
      atcButton.style.opacity = '1';
      atcButton.style.cursor = 'pointer';
    }
    setATCOverlay(false);
  }
  
  // Control customize button (new logic)
  if (customizeButton) {
    const uploadFieldsExist = hasUploadFields();
    console.log('Customize button evaluation:', {
      uploadFieldsExist,
      sideADuration: window.vinylDurations.sideA,
      sideBDuration: window.vinylDurations.sideB,
      sideAExceeded,
      sideBExceeded
    });
    
    if (!uploadFieldsExist) {
      // No upload fields, don't block the customize button
      customizeButton.disabled = false;
      customizeButton.style.opacity = '1';
      customizeButton.style.cursor = 'pointer';
      setATCOverlay(false, '#zakeke-product-button', 'customize-block-overlay');
      console.log('Customize button unblocked - no upload fields');
    } else {
      // Upload fields exist, check conditions
      const allSidesHaveFiles = hasFilesForAllSides();
      const shouldBlock = !allSidesHaveFiles || sideAExceeded || sideBExceeded;
      
      console.log('Customize button conditions:', {
        allSidesHaveFiles,
        shouldBlock,
        reason: !allSidesHaveFiles ? 'missing files' : (sideAExceeded || sideBExceeded) ? 'duration exceeded' : 'none'
      });
      
      if (shouldBlock) {
        // Block customize button
        customizeButton.disabled = true;
        customizeButton.style.opacity = '0.5';
        customizeButton.style.cursor = 'not-allowed';
        setATCOverlay(true, '#zakeke-product-button', 'customize-block-overlay');
        console.log('Customize button blocked');
      } else {
        // Unblock customize button
        customizeButton.disabled = false;
        customizeButton.style.opacity = '1';
        customizeButton.style.cursor = 'pointer';
        setATCOverlay(false, '#zakeke-product-button', 'customize-block-overlay');
        console.log('Customize button unblocked');
      }
    }
  }
}

function showDurationWarnings(sideAExceeded, sideBExceeded) {
  const config = window.vinylConfig;
  const uploadMusicContainer = document.querySelector('.upload-music');
  if (!uploadMusicContainer || !config) return;
  
  // Create warning container
  const warningContainer = document.createElement('div');
  warningContainer.className = 'vinyl-duration-warning';
  warningContainer.style.cssText = `
    background-color: #f8d7da;
    color: #721c24;
    padding: 12px 16px;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    margin: 15px 0;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 500;
  `;
  
  let warningContent = `<strong>${config.strings.warningTitle}</strong><br>`;
  
  if (sideAExceeded) {
    const minutes = (window.vinylDurations.sideA / 60).toFixed(1);
    warningContent += `<strong>${config.strings.sideALabel}</strong> ${minutes} ${config.strings.minutesText} (${config.strings.maxMinutesText.replace('{{ max_minutes }}', config.maxMinutes)})<br>`;
  }
  
  if (sideBExceeded) {
    const minutes = (window.vinylDurations.sideB / 60).toFixed(1);
    warningContent += `<strong>${config.strings.sideBLabel}</strong> ${minutes} ${config.strings.minutesText} (${config.strings.maxMinutesText.replace('{{ max_minutes }}', config.maxMinutes)})<br>`;
  }
  
  warningContent += `<br>${config.strings.instructionText}`;
  
  warningContainer.innerHTML = warningContent;
  
  // Insert after the upload-music container
  uploadMusicContainer.parentNode.insertBefore(warningContainer, uploadMusicContainer.nextSibling);
}

function getSideFromLabel(labelText) {
  if (!labelText) return null;
  const lowerLabel = labelText.toLowerCase();
  if (lowerLabel.includes('side a') || lowerLabel.includes('(a)')) return 'sideA';
  if (lowerLabel.includes('side b') || lowerLabel.includes('(b)')) return 'sideB';
  return null;
}

function hasUploadFields() {
  return document.querySelectorAll('.uploadkit-uploader.uploadkit-upload-field').length > 0;
}

function getRequiredSides() {
  const uploaders = document.querySelectorAll('.uploadkit-uploader.uploadkit-upload-field');
  const sides = new Set();
  
  uploaders.forEach(uploader => {
    const labelText = uploader.querySelector('.uploadkit-label')?.textContent || '';
    const side = getSideFromLabel(labelText);
    if (side) {
      sides.add(side);
    }
  });
  
  return Array.from(sides);
}

function hasFilesForAllSides() {
  const requiredSides = getRequiredSides();
  console.log('Checking required sides:', requiredSides);
  
  for (const side of requiredSides) {
    // Check if this side has any files by looking for uploadkit-file-listing elements
    const uploaders = document.querySelectorAll('.uploadkit-uploader.uploadkit-upload-field');
    let hasFilesForThisSide = false;
    
    uploaders.forEach(uploader => {
      const labelText = uploader.querySelector('.uploadkit-label')?.textContent || '';
      const uploaderSide = getSideFromLabel(labelText);
      if (uploaderSide === side) {
        // Check for file listings in the uploader
        const fileListings = uploader.querySelectorAll('.uploadkit-file-listing');
        const attributeContainer = uploader.querySelector('.uploadkit-attribute-container input[type="hidden"]');
        
        // Consider it has files if there are visible file listings or hidden input with value
        if (fileListings.length > 0 || (attributeContainer && attributeContainer.value.trim() !== '')) {
          hasFilesForThisSide = true;
          console.log(`Side ${side} has files: ${fileListings.length} listings, input value: ${attributeContainer?.value || 'none'}`);
        }
      }
    });
    
    if (!hasFilesForThisSide) {
      console.log(`Side ${side} has no files`);
      return false;
    }
  }
  
  console.log('All required sides have files:', requiredSides.length > 0);
  return requiredSides.length > 0; // Return true only if there are required sides and all have files
}

function calculateTotalDurationForSide(uploaderId, side) {
  // Find all uploaders for this side
  const uploaders = document.querySelectorAll(`[data-uploader-id="${uploaderId}"]`);
  if (uploaders.length === 0) return;
  
  // Get all files from UploadKit for this uploader
  let totalDuration = 0;
  let pendingCalculations = 0;
  
  // We need to access the UploadKit data to get all files for this uploader
  if (window.UploadKit && window.UploadKit.getFiles) {
    const files = window.UploadKit.getFiles(uploaderId);
    if (files && files.length > 0) {
      pendingCalculations = files.length;
      
      files.forEach(file => {
        const cdnUrl = file.fileInfo ? file.fileInfo.cdnUrl : file.cdnUrl;
        if (cdnUrl) {
          getDuration(cdnUrl)
            .then(duration => {
              totalDuration += duration;
              pendingCalculations--;
              if (pendingCalculations === 0) {
                window.vinylDurations[side] = totalDuration;
                updateATCButton();
              }
            })
            .catch(error => {
              console.error('Error calculating duration:', error);
              pendingCalculations--;
              if (pendingCalculations === 0) {
                window.vinylDurations[side] = totalDuration;
                updateATCButton();
              }
            });
        } else {
          pendingCalculations--;
          if (pendingCalculations === 0) {
            window.vinylDurations[side] = totalDuration;
            updateATCButton();
          }
        }
      });
    } else {
      // No files, reset duration for this side
      window.vinylDurations[side] = 0;
      updateATCButton();
    }
  }
}
  
/* ---------- UploadKit listener ---------- */
window.UploadKit = window.UploadKit || {};
window.UploadKit.callbacks = window.UploadKit.callbacks || {};

window.UploadKit.callbacks.afterRefresh = function (data) {
  console.log('afterRefresh', data);
  
  const config = window.vinylConfig;
  if (!config) {
    console.error('Vinyl configuration not found');
    return;
  }
  
  // Determine which side this uploader is for
  const labelText = data.uploader?.formLabelText || data.uploader?.name || '';
  const side = getSideFromLabel(labelText);
  
  if (!side) {
    console.warn('Could not determine vinyl side from label:', labelText);
    return;
  }

  console.log(config.strings.processingFiles.replace('{{ side }}', side).replace('{{ label }}', labelText));

  // If no files, reset duration for this side
  if (!data.files?.length) {
    window.vinylDurations[side] = 0;
    console.log(config.strings.noFilesReset.replace('{{ side }}', side));
    updateATCButton();
    return;
  }

  // Calculate total duration for all files in this uploader
  let totalDuration = 0;
  let pendingCalculations = 0;
  const seen = new Set();

  // Helper function to check if file is audio
  function isAudioFile(filename, mimeType) {
    if (mimeType && mimeType.startsWith('audio/')) return true;
    if (filename) {
      const extension = filename.toLowerCase().split('.').pop();
      return ['mp3', 'wav', 'ogg', 'flac', 'm4a', 'aac'].includes(extension);
    }
    return false;
  }

  data.files.forEach(wrapper => {
    const uuid = wrapper.fileInfo?.uuid;
    if (seen.has(uuid)) return;
    seen.add(uuid);

    const filename = wrapper.fileInfo?.name || '';
    const mimeType = wrapper.fileInfo?.mimeType || wrapper.fileInfo?.originalContentInfo?.mime?.mime || '';
    
    // Skip non-audio files
    if (!isAudioFile(filename, mimeType)) {
      console.log(config.strings.skippingNonAudio.replace('{{ filename }}', filename));
      return;
    }

    pendingCalculations++;

    /* локальный файл (до загрузки) */
    if (wrapper.sourceInfo?.file instanceof File) {
      getDuration(URL.createObjectURL(wrapper.sourceInfo.file))
        .then(sec => {
          console.log(config.strings.localFile.replace('{{ filename }}', wrapper.fileInfo.name).replace('{{ duration }}', sec.toFixed(2)));
          totalDuration += sec;
          pendingCalculations--;
          if (pendingCalculations === 0) {
            window.vinylDurations[side] = totalDuration;
            console.log(config.strings.totalDuration.replace('{{ side }}', side).replace('{{ duration }}', totalDuration.toFixed(2)).replace('{{ minutes }}', (totalDuration/60).toFixed(1)));
            updateATCButton();
          }
        })
        .catch(error => {
          console.error(config.strings.errorLocal, error);
          pendingCalculations--;
          if (pendingCalculations === 0) {
            window.vinylDurations[side] = totalDuration;
            updateATCButton();
          }
        });
    } else if (wrapper.fileInfo?.cdnUrl) {
      /* уже загруженный файл */
      getDuration(wrapper.fileInfo.cdnUrl)
        .then(sec => {
          console.log(config.strings.uploadedFile.replace('{{ filename }}', wrapper.fileInfo.name).replace('{{ duration }}', sec.toFixed(2)));
          totalDuration += sec;
          pendingCalculations--;
          if (pendingCalculations === 0) {
            window.vinylDurations[side] = totalDuration;
            console.log(config.strings.totalDuration.replace('{{ side }}', side).replace('{{ duration }}', totalDuration.toFixed(2)).replace('{{ minutes }}', (totalDuration/60).toFixed(1)));
            updateATCButton();
          }
        })
        .catch(error => {
          console.error(config.strings.errorUploaded, error);
          pendingCalculations--;
          if (pendingCalculations === 0) {
            window.vinylDurations[side] = totalDuration;
            updateATCButton();
          }
        });
    } else {
      // File without URL (shouldn't happen, but handle gracefully)
      pendingCalculations--;
      if (pendingCalculations === 0) {
        window.vinylDurations[side] = totalDuration;
        updateATCButton();
      }
    }
  });

  // If no valid audio files to process, reset duration for this side
  if (pendingCalculations === 0) {
    window.vinylDurations[side] = totalDuration;
    console.log(config.strings.noValidFiles.replace('{{ side }}', side).replace('{{ duration }}', totalDuration));
    updateATCButton();
  }
};

// Function to initialize customize button blocking
function initializeCustomizeButton() {
  const customizeButton = document.querySelector('#zakeke-product-button');
  if (customizeButton && hasUploadFields()) {
    // Block customize button initially if upload fields exist
    customizeButton.disabled = true;
    customizeButton.style.opacity = '0.5';
    customizeButton.style.cursor = 'not-allowed';
    setATCOverlay(true, '#zakeke-product-button', 'customize-block-overlay');
    console.log('Customize button blocked until music is uploaded');
  }
}

// Initialize button state on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeCustomizeButton();
  updateATCButton();
  
  // Watch for dynamically added customize button
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is the customize button or contains it
          if (node.id === 'zakeke-product-button' || 
              (node.querySelector && node.querySelector('#zakeke-product-button'))) {
            console.log('Customize button detected, initializing blocking');
            initializeCustomizeButton();
            updateATCButton();
          }
        }
      });
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
  